exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".unusual .unusual-middle[data-v-32884ca2]{vertical-align:middle}\n", ""]);

